import { createComponent } from '@common/util/templateHelpers';

const Menu = createComponent('Menu', 
  {}, 
  function Menu ({ className, style }, props) {
    return (
      <div className={className} style={style}>
        {props.children}
      </div>
    );
  });
export default Menu;

/* --- */

export const MenuList = createComponent('MenuList', 
  {}, 
  function MenuList ({ className, style }, props) {
    return (
      <ul className={className} style={style}>
        {props.children}
      </ul>
    );
  });

/* --- */

export const MenuLabel = createComponent('MenuLabel', 
  {}, 
  function MenuLabel ({ className, style }, props) {
    return (
      <p className={className} style={style}>
        {props.children}
      </p>
    );
  });
